import config from "./config";

var net = {};
if (
  config.EnvName === "demo" ||
  config.EnvName === "local" ||
  config.EnvName === "stage"
) {
  net = {
    11155111: {
      // Sepolia_Testnet
      //demo
      // chain: "ETH",
      // rpcUrl: "https://sepolia.infura.io/v3/6bcc2d2f4a6e45de849563164d80ca26",

      // networkVersion: "11155111",
      // chainId: "11155111",
      // currencySymbol: "ETH",
      // tokenSymbol: "GALFI",
      // tokenAddress: "0xc6aBa068A91d327B259327523f71f51221943186".toLowerCase(),
      // tradeContract: "0x54677298c49d19a2335aEf2B32ae3d643f9ccf1B".toLowerCase(),
      // singleContract:
      //   "0x362836C8be9f0487309cf962cc36Ed6e90177937".toLowerCase(),
      // multipleContract:
      //   "0x708390Ff3f96F4F46761319E07c50f0DADC22E66".toLowerCase(),
      // adminAddrsss: "0x025c1667471685c323808647299e5dbf9d6adcc9".toLowerCase(),
      // siteUrl: "https://testnet.snowtrace.io",
      // deadaddress: "0x000000000000000000000000000000000000dEaD".toLowerCase(),
      // chainName: "ETHER_TESTNET",

      //staging
        chain: "ETH",
      rpcUrl: "https://sepolia.infura.io/v3/6bcc2d2f4a6e45de849563164d80ca26",

      networkVersion: "11155111",
      chainId: "11155111",
      currencySymbol: "ETH",
      tokenSymbol: "GALFI",
      tokenAddress: "0xc6aBa068A91d327B259327523f71f51221943186".toLowerCase(),
      tradeContract: "0xb7765862A5ce4fc48AABBCcd2d0660D6330a6216".toLowerCase(),
      singleContract:
        "0x362836C8be9f0487309cf962cc36Ed6e90177937".toLowerCase(),
      multipleContract:
        "0x708390Ff3f96F4F46761319E07c50f0DADC22E66".toLowerCase(),
      adminAddrsss: "0x5c985839aC19164D9386E21C4d8a3857d0934c7a".toLowerCase(),
      siteUrl: "https://testnet.snowtrace.io",
      deadaddress: "0x000000000000000000000000000000000000dEaD".toLowerCase(),
      chainName: "ETHER_TESTNET",
    },
  };
}

export const network = net;

// https://testnet.bscscan.com/address/0xFcf543deBda0AC9694DA193553b790de2C51E321#readProxyContract
